export const formatAffiliateCurrency = (value, currency = 'FCFA') => {
  const amount = Number(value || 0);
  return `${amount.toLocaleString('fr-FR')} ${currency}`;
};

export const formatAffiliateDate = (value, options = {}) => {
  if (!value) {
    return '-';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '-';
  }
  return date.toLocaleDateString('fr-FR', options);
};

export const formatAffiliateDateTime = (value) => {
  if (!value) {
    return '-';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '-';
  }
  return `${date.toLocaleDateString('fr-FR')} ${date.toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
  })}`;
};

export const normalizeAffiliateType = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === 'super_ambassador') return 'super_ambassador';
  return normalized === 'ambassador' ? 'ambassador' : 'seller';
};

export const getAffiliateTypeLabel = (value) => {
  const normalized = normalizeAffiliateType(value);
  if (normalized === 'super_ambassador') return 'Super ambassadeur';
  return normalized === 'ambassador' ? 'Ambassadeur' : 'Affiliation vendeur';
};

export const getAffiliateStatusLabel = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === 'active') return 'Actif';
  if (normalized === 'suspended') return 'Suspendu';
  return 'En attente';
};

export const getAffiliateStatusToneClasses = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === 'active') return 'bg-emerald-100 text-emerald-800 border-emerald-200';
  if (normalized === 'suspended') return 'bg-amber-100 text-amber-900 border-amber-200';
  return 'bg-slate-100 text-slate-700 border-slate-200';
};

export const getPayoutStatusLabel = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === 'paid') return 'Paye';
  if (normalized === 'approved') return 'Disponible';
  if (normalized === 'rejected') return 'Rejete';
  if (normalized === 'cancelled_duplicate') return 'Annule';
  return 'En attente';
};

export const getPayoutStatusVariant = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === 'paid') return 'default';
  if (normalized === 'approved') return 'secondary';
  if (normalized === 'rejected' || normalized === 'cancelled_duplicate') return 'destructive';
  return 'outline';
};

export const getAffiliateBackPath = (affiliateType) => (
  normalizeAffiliateType(affiliateType) === 'seller' ? '/vendeur' : '/'
);

export const getAffiliateBackLabel = (affiliateType) => (
  normalizeAffiliateType(affiliateType) === 'seller' ? 'Retour vendeur' : 'Retour accueil'
);
